import { Component } from '@theme/component';

class BarryBookingBanner extends Component {
  reduced = matchMedia('(prefers-reduced-motion: reduce)');
  controller;
  connectedCallback() {
    super.connectedCallback();
    this.setup();
  }
  updatedCallback() {
    super.updatedCallback();
    this.setup();
  }
  setup() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.dataset.ready = 'true';
    this.syncControl();
    this.reduced.addEventListener('change', () => this.syncControl(), { signal: this.controller.signal });
  }
  syncControl() {
    if (this.refs.pause) this.refs.pause.hidden = this.reduced.matches;
  }
  toggleMotion() {
    const button = this.refs.pause;
    if (!button) return;
    const paused = this.dataset.paused !== 'true';
    this.dataset.paused = String(paused);
    button.setAttribute('aria-pressed', String(paused));
    button.setAttribute('aria-label', paused ? button.dataset.resume : button.dataset.pause);
    button.textContent = paused ? button.dataset.playSymbol : button.dataset.pauseSymbol;
  }
  disconnectedCallback() {
    this.controller?.abort();
    super.disconnectedCallback();
  }
}
if (!customElements.get('bc-booking-banner')) customElements.define('bc-booking-banner', BarryBookingBanner);
